// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-layout {
  display: grid;
  grid-template-columns: 1fr 1.2fr;
  gap: 48px;
  align-items: start;
}

.contact-info h2 {
  font-size: 2rem;
  margin-bottom: 12px;
}

.contact-info > p {
  color: var(--text-mid);
  line-height: 1.8;
  margin-bottom: 28px;
}

.info-cards {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 32px;
}

.info-card {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 20px 24px;
}

.info-icon {
  font-size: 1.8rem;
  flex-shrink: 0;
}

.info-card h4 {
  font-size: 0.9rem;
  margin-bottom: 4px;
  color: var(--gold-dark);
}

.info-card p {
  font-size: 0.85rem;
  color: var(--text-mid);
  line-height: 1.7;
}

.social-section h3 {
  font-size: 1rem;
  margin-bottom: 12px;
}

.social-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.social-link-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 18px;
  border: 1.5px solid rgba(200,134,10,0.25);
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-mid);
  transition: all 0.2s ease;
  cursor: pointer;
}

.social-link-btn svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.social-link-btn:hover {
  border-color: var(--gold);
  color: var(--gold-dark);
  background: rgba(200,134,10,0.06);
}

/* Form */
.contact-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-form h2 {
  font-size: 1.5rem;
  margin-bottom: 4px;
}

.field-row-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.cfield-group {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.cfield-group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--gold-dark);
}

.form-input {
  padding: 12px 16px;
  border: 1.5px solid rgba(200,134,10,0.2);
  border-radius: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 0.9rem;
  color: var(--text-dark);
  background: var(--cream);
  outline: none;
  transition: border-color 0.2s ease;
  width: 100%;
}

.form-input:focus {
  border-color: var(--gold);
}

textarea.form-input {
  resize: vertical;
}

select.form-input {
  cursor: pointer;
}

/* FAQ */
.faq-section {
  background: var(--cream-dark);
}

.faq-list {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-item {
  padding: 0;
  overflow: hidden;
}

.faq-question {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  background: transparent;
  border: none;
  font-family: 'Poppins', sans-serif;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--brown);
  cursor: pointer;
  text-align: left;
  gap: 16px;
  transition: color 0.2s ease;
}

.faq-item.open .faq-question {
  color: var(--gold-dark);
}

.faq-icon {
  font-size: 1.4rem;
  font-weight: 400;
  color: var(--gold);
  flex-shrink: 0;
}

.faq-answer {
  padding: 0 24px 20px;
  font-size: 0.9rem;
  color: var(--text-mid);
  line-height: 1.8;
  border-top: 1px solid rgba(200,134,10,0.1);
  padding-top: 16px;
  margin: 0 24px 20px;
}

/* Success */
.success-card h2 {
  font-size: 1.8rem;
  margin: 16px 0 12px;
}

.success-card p {
  color: var(--text-mid);
  line-height: 1.8;
}

@media (max-width: 900px) {
  .contact-layout {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .field-row-2 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,kCAAkC;EAClC,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,aAAa;EACb,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,QAAQ;AACR;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".contact-layout {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr;\n  gap: 48px;\n  align-items: start;\n}\n\n.contact-info h2 {\n  font-size: 2rem;\n  margin-bottom: 12px;\n}\n\n.contact-info > p {\n  color: var(--text-mid);\n  line-height: 1.8;\n  margin-bottom: 28px;\n}\n\n.info-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 32px;\n}\n\n.info-card {\n  display: flex;\n  gap: 16px;\n  align-items: flex-start;\n  padding: 20px 24px;\n}\n\n.info-icon {\n  font-size: 1.8rem;\n  flex-shrink: 0;\n}\n\n.info-card h4 {\n  font-size: 0.9rem;\n  margin-bottom: 4px;\n  color: var(--gold-dark);\n}\n\n.info-card p {\n  font-size: 0.85rem;\n  color: var(--text-mid);\n  line-height: 1.7;\n}\n\n.social-section h3 {\n  font-size: 1rem;\n  margin-bottom: 12px;\n}\n\n.social-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.social-link-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 9px 18px;\n  border: 1.5px solid rgba(200,134,10,0.25);\n  border-radius: 50px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-mid);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.social-link-btn svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.social-link-btn:hover {\n  border-color: var(--gold);\n  color: var(--gold-dark);\n  background: rgba(200,134,10,0.06);\n}\n\n/* Form */\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.contact-form h2 {\n  font-size: 1.5rem;\n  margin-bottom: 4px;\n}\n\n.field-row-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.cfield-group {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n\n.cfield-group label {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--gold-dark);\n}\n\n.form-input {\n  padding: 12px 16px;\n  border: 1.5px solid rgba(200,134,10,0.2);\n  border-radius: 10px;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.9rem;\n  color: var(--text-dark);\n  background: var(--cream);\n  outline: none;\n  transition: border-color 0.2s ease;\n  width: 100%;\n}\n\n.form-input:focus {\n  border-color: var(--gold);\n}\n\ntextarea.form-input {\n  resize: vertical;\n}\n\nselect.form-input {\n  cursor: pointer;\n}\n\n/* FAQ */\n.faq-section {\n  background: var(--cream-dark);\n}\n\n.faq-list {\n  max-width: 800px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faq-item {\n  padding: 0;\n  overflow: hidden;\n}\n\n.faq-question {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  background: transparent;\n  border: none;\n  font-family: 'Poppins', sans-serif;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--brown);\n  cursor: pointer;\n  text-align: left;\n  gap: 16px;\n  transition: color 0.2s ease;\n}\n\n.faq-item.open .faq-question {\n  color: var(--gold-dark);\n}\n\n.faq-icon {\n  font-size: 1.4rem;\n  font-weight: 400;\n  color: var(--gold);\n  flex-shrink: 0;\n}\n\n.faq-answer {\n  padding: 0 24px 20px;\n  font-size: 0.9rem;\n  color: var(--text-mid);\n  line-height: 1.8;\n  border-top: 1px solid rgba(200,134,10,0.1);\n  padding-top: 16px;\n  margin: 0 24px 20px;\n}\n\n/* Success */\n.success-card h2 {\n  font-size: 1.8rem;\n  margin: 16px 0 12px;\n}\n\n.success-card p {\n  color: var(--text-mid);\n  line-height: 1.8;\n}\n\n@media (max-width: 900px) {\n  .contact-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .field-row-2 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
